import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';

import { ContactPage } from 'components/ExpertSearch/mtn/components/ContactPage/ContactPage';
import { mtnData } from 'components/ExpertSearch/mtn/data';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';

export const AnsprechpartnerContactPageComponent = (props) => {
  const { pageType } = props;
  const isEditor = Utils.isInEditor();

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="AnsprechpartnerContactPage" />;
  }
  if (!pageType) {
    return <div>Daten nicht gefunden</div>;
  }
  const pageData = pageType.split('-').reduce((acc, curr) => acc && acc[curr], mtnData);

  if (!pageData) {
    return <div>Daten nicht gefunden</div>;
  }
  return <ContactPage pageData={pageData} />;
};

AnsprechpartnerContactPageComponent.propTypes = {
  pageType: PropTypes.string.isRequired,
};

MapTo('e-fix/components/content/ansprechpartnercontactpage')(AnsprechpartnerContactPageComponent);
